import { Permission } from '_metronic/helpers'
import { useAuth } from '../../../../auth'

/**
 * Gate de UI do envio manual da Ficha de Cadastro Individual (F7c).
 *
 * LIMITAÇÃO CONHECIDA (a mesma de `envios/core/_esusEnvioPermissao.ts`): `/usuarios/me` devolve
 * `UsuarioDtoVinculo`, cujo `grupo` é montado por `new GrupoDto(...)` — construtor que NÃO preenche
 * `perfis`. O cliente só conhece o NOME DO GRUPO, nunca as permissões efetivas. Por isso este gate é
 * **defesa em profundidade**, nunca a única barreira: todo caminho de erro do backend (403, 422)
 * continua tratado no diálogo mesmo quando o gate deixa passar.
 *
 * A lista abaixo é a de `Esus:cadastro` no `permission.json` (linhas 907-912) — **não** a de
 * `Esus:read`/`Esus:resend`, que só tem SUPER_ADMIN/ADMIN. Copiar aquelas esconderia a ação
 * justamente de quem atende o paciente (MEDICO, SUPER_MEDICO, EMPLOYEE).
 */
export const GRUPOS_ESUS_CADASTRO: Permission[] = [
  Permission.SuperAdmin,
  Permission.SuperMedico,
  Permission.Admin,
  Permission.Medico,
  Permission.Employee,
]

/**
 * As mensagens moram em `_esusCadastroMensagens.ts`, sem imports, e são reexportadas aqui: este
 * arquivo depende de `auth` e quem só precisa do texto (o diálogo) não pode arrastar o app inteiro.
 */
export { MSG_403_SESSAO_ANTERIOR, MSG_SEM_PERMISSAO_ESUS_CADASTRO } from './_esusCadastroMensagens'

const useGrupoEm = (grupos: Permission[]): boolean => {
  const { currentUser } = useAuth()
  return grupos.includes(currentUser?.grupo?.nome as Permission)
}

/** Pode disparar o envio manual do cadastro do cidadão (`Esus:cadastro`). */
export const usePermissaoEsusCadastro = (): boolean => useGrupoEm(GRUPOS_ESUS_CADASTRO)
